'use es6';

import PropTypes from 'prop-types';
import { useRef, useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ColorPickerShim({
  color,
  onChange,
  open
}) {
  const inputEl = useRef(null);
  useEffect(() => {
    if (open) inputEl.current.click();
  }, [open]);
  return /*#__PURE__*/_jsx("input", {
    className: "hidden",
    type: "color",
    value: color,
    onChange: onChange,
    ref: inputEl
  });
}
ColorPickerShim.propTypes = {
  color: PropTypes.string,
  onChange: PropTypes.func,
  open: PropTypes.bool.isRequired
};
ColorPickerShim.displayName = 'ColorPickerShim';